import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { listDocumentTypeVersions, SchemaQueryKeys, type DocumentTypeResponse } from '../api';

/** Lists every published version of a slug, ordered version-descending by the backend. */
export function useDocumentTypeVersions(
  slug: string | undefined,
): UseQueryResult<DocumentTypeResponse[]> {
  return useQuery({
    queryKey: SchemaQueryKeys.versions(slug ?? ''),
    queryFn: ({ signal }) => listDocumentTypeVersions(slug as string, signal),
    enabled: slug !== undefined && slug !== '',
  });
}
